import React from 'react';
import { connect } from 'react-redux';
import {
  Form,
  Control,
  actions
} from 'react-redux-form';
import {
  add_columns,
  reset_entry_errors
} from "../actions"
import Errors from './Errors'

const mapStateToProps = state => {
  return {
    form: state.forms.newColumns,
    removed_keys: state.entry.removed_keys,
    errors: state.entry.errors,
    adding_columns: state.entry.adding_columns
  };
}

const mapDispatchToProps = dispatch => {
  return {
    addColumns: (report_id, column_string, before) => dispatch( add_columns(report_id, column_string, before) ),
    resetForm: () => dispatch( actions.reset('newColumns') ),
    resetErrors: () => dispatch ( reset_entry_errors() )
  };
}

class ConnectedNewColumns extends React.Component {
  constructor () {
    super()
    this.state = {
      selector: null
    }
  }

  handleSubmit(values) {
    const { report_id, addColumns } = this.props;
    const { keys, before } = values;
    addColumns(report_id, keys, before)
  }

  componentDidMount() {
    const elem = document.getElementById('thebefore')
    const selector = window.M.FormSelect.init(elem);
    this.setState({selector: selector})
  }

  hide() {
    this.props.hide()
    this.props.resetForm()
    this.props.resetErrors()
  }

  componentDidUpdate(prevProps, prevState) {
    const {columns, adding_columns, isHidden} = this.props
    const prevcolumns = prevProps.columns
    const prevAddingColumns = prevProps.adding_columns
    const wasHidden = prevProps.isHidden

    if (isHidden && !wasHidden) {
      // this.hide()
      this.props.resetForm()
      this.props.resetErrors()
    } else {

      if ( JSON.stringify(columns) !== JSON.stringify(prevcolumns) ) {
        const fs = this.state.selector
        fs.destroy()
        const elem = document.getElementById('thebefore')
        const selector = window.M.FormSelect.init(elem);
        this.setState({selector: selector})
      }

      if ( adding_columns !== prevAddingColumns ) {
        if ( prevAddingColumns ) {
          this.hide()
        }
      }
    }

  }

  componentWillUnmount() {
    this.props.resetForm()
  }

  render() {

    const {isHidden, columns, removed_keys} = this.props
    const { hide } = this
    const remkeys = ( removed_keys !== undefined && removed_keys !== null && removed_keys.length > 0) ? (
      <div className="section removed_keys">
        * Columns removed from this report: {removed_keys.join(", ")}
      </div>
    ) : ''
    return(
      <Form
        model="newColumns"
        className={isHidden ? 'hide' : ''}
        onSubmit = { (values) => {
          this.handleSubmit(values)
        }}
      >
        <div className="section">
          <div className="input-field">
            <label htmlFor="thekeys">Give column names, separated by commas (eg. "col1, col2")</label>
            <Control.text id="thekeys" model= "newColumns.keys" />
          </div>
        </div>

        <div className="section">
          <div className="input-field">
            <label htmlFor="thebefore" className="active">Select existing column to insert before</label>
            <Control.select id="thebefore" model= "newColumns.before">
              <option value="">Place at the end</option>
              {
                columns.map( (column, index) => {
                  if (column.key !== "title_length") {
                    return(
                      <option value={column.key} key={index}>{column.name}</option>
                    )
                  } else {
                    return null
                  }
                })
              }
            </Control.select>
          </div>
        </div>

        <Errors errors={this.props.errors} />

        <div className="section">
          <button className="btn red darken-1 waves-effect waves-light mr-10" onClick={(e)=>{
            e.preventDefault()
            hide()
          }}>Cancel</button>
          <button type="submit" className="btn red darken-1 waves-effect waves-light"><i className="material-icons right">navigate_next</i>ADD COLUMNS</button>
        </div>

        { remkeys }
      </Form>
    )
  }
}


const NewColumns = connect(mapStateToProps, mapDispatchToProps)(ConnectedNewColumns);

export default NewColumns;



// WEBPACK FOOTER //
// ./src/js/components/NewColumns.js